import React from 'react';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TabHeaderSkeleton } from './components/TabHeaderSkeleton';

interface Props {
  title?: string;
}

export const TabHeaderLoading: React.FC<Props> = ({ title }) => {
  return (
    <TabHeaderSkeleton title={title}>
      <Shimmer width="350px" height="24px" />
    </TabHeaderSkeleton>
  );
};
